// At least 8 characters AND one special char AND one letter
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/

// Boutique retenue par défaut quand aucune n'est choisie : la première cabane.
export const DEFAULT_STORE_ID = 3
